import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

import type { FleetSafetyAggregatedBy, FleetSafetyReportRequest, FleetSafetyRequest, FleetSafetyResponse } from '@cobliteam/api-lib';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';

export class FleetSafetyRequester {
  private requester: Requester;

  private baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/analytics/v1';
  }

  public getFleetSafety = async (request: FleetSafetyRequest, aggregatedBy: FleetSafetyAggregatedBy): Promise<FleetSafetyResponse> => {
    const requestData = {
      endpoint: `${this.baseUrl}/safety/${aggregatedBy}`,
      method: HttpMethod.POST,
      body: JSON.stringify(
        snakecaseKeys({
          ...request,
          timezone: TimeZone.getTimezone(),
        })
      ),
    };

    const response = await this.requester.request(requestData);
    return camelcaseKeys(response.data.data, { deep: true });
  };

  public getFleetHasCameraProEventsFlag = async (): Promise<boolean> => {
    const requestData = {
      endpoint: `${this.baseUrl}/safety/camera-pro`,
      method: HttpMethod.GET,
    };

    const response = await this.requester.request(requestData);
    return camelcaseKeys(response.data.data, { deep: true }).fleetHasCameraProEvents;
  };

  public requestFleetSafetyReport = async (request: FleetSafetyReportRequest): Promise<string> => {
    const requestBody = {
      ...snakecaseKeys(request),
      timezone: TimeZone.getTimezone(),
    };

    const requestData = {
      endpoint: `${this.baseUrl}/safety/report/mail`,
      method: HttpMethod.POST,
      body: JSON.stringify(requestBody),
    };

    const response = await this.requester.request(requestData);
    return response.data.data;
  };
}

export default FleetSafetyRequester;
